import { render, staticRenderFns } from "./VendorEditPage.vue?vue&type=template&id=46268022&scoped=true&"
import script from "./VendorEditPage.vue?vue&type=script&lang=js&"
export * from "./VendorEditPage.vue?vue&type=script&lang=js&"
import style0 from "./VendorEditPage.vue?vue&type=style&index=0&id=46268022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46268022",
  null
  
)

export default component.exports